@if (showCard.showCardIziCardOwner) {
	<cv-page-card-holder></cv-page-card-holder>
}

@if (showCard.showCardInfoBilling) {
	<cv-page-info-billing></cv-page-info-billing>
}

@if (showCard.showCaradIziPay) {
	<cv-izipay-page></cv-izipay-page>
}

@if (showCard.showCaradIziResume) {
	<cv-page-transfer-resume></cv-page-transfer-resume>
}

@if (showCard.showCardIziError) {
	<cv-page-error-global></cv-page-error-global>
}
